var GoogleMarkerOrder = {
    selectedSite: 999999,
    selectedMast: 99999,
    cluster: 3,
    mast: 2,
    site: 1
};

export { GoogleMarkerOrder as G };
